var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services-page mt-0"},[_c('SkeletonLoader',{attrs:{"isContentLoaded":_vm.isContentLoaded}}),(_vm.isContentLoaded)?_c('div',[_c('main',[_c('ServiceBanner'),_c('ServiceCard'),_c('AboutInfo')],1),_c('FootInfo')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }